var ResetPasswordOutput = /** @class */ (function () {
    function ResetPasswordOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordOutput.prototype.init = function (data) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    };
    ResetPasswordOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordOutput();
        result.init(data);
        return result;
    };
    ResetPasswordOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    };
    ResetPasswordOutput.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ResetPasswordOutput();
        result.init(json);
        return result;
    };
    return ResetPasswordOutput;
}());
export { ResetPasswordOutput };
